import TrainFormatterHelper from "../../../../util/formatter/TrainFormatterHelper";

// 查看凭证
export default {
    name: "LookVoucherDialog",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {};
    },
    watch: {
        visible: {
            immediate: true,
            handler(val) {
                if (val) {
                }
            },
        },
    },
    methods: {
        /**
         * 关闭
         */
        onCloseEvent() {
            this.$emit("update:visible", false);
        },
        /**
         * 处理操作类型
         */
        formatterSignType(item) {
            if (!item || !item.signType) {
                return "-";
            }
            // 签到类型（10：签到，20：抽验，30：签退 40: 上课验证）
            switch (item.signType) {
                case 10: {
                    return "签到";
                }
                case 20: {
                    return "抽验";
                }
                case 30: {
                    return "签退";
                }
                case 40: {
                    return "上课验证";
                }
                default: {
                    return "未知";
                }
            }
        },
        /**
         * 处理方式
         */
        formatterCellValue(val) {
            if (val && val.length > 0) {
                return val;
            }
            return "-";
        },
    },
};
